import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import VVSTable from "components/form-control/VVSTable";
import { template } from "constants/dataTempleteExcel";
import VVSSelectModel from "components/form-control/VVSSelectModel";
import { useForm } from "react-hook-form";
import { language_vn } from "helpers/language_vn";

const Lead = () => {
  const [employeeGroup, setEmployeeGroup] = useState({});
  const [employee, setEmployee] = useState({});
  const { handleSubmit, ...rest } = useForm({
    mode: "onBlur",
  });

  const onSubmit = async values => {
    console.log("values", values);
  };

  const getFilterLead = (group, employee) => {
    return {
      ...(group?.objectId && {
        salesTeam: {
          objectId: group.objectId,
          className: "EmployeeGroup",
          __type: "Pointer",
        },
      }),
      ...(employee?.objectId && {
        salesStaff: {
          objectId: employee.objectId,
          className: "Employee",
          __type: "Pointer",
        },
      }),
    };
  };

  return (
    <div className="page-content">
      <form onSubmit={handleSubmit(onSubmit)}>
        <Row
          style={{
            position: "relative",
            marginBottom: "-35px",
            zIndex: 99,
            width: "max-content",
          }}
        >
          <h4 className="my-0 font-size-18 text-capitalize mb-2">
            Quản lí khách hàng tiềm năng
          </h4>
          <Col sm={6}>
            <VVSSelectModel
              name="salesTeam"
              model="EmployeeGroup"
              {...rest}
              conditionField={{ isActive: true }}
              onSelect={setEmployeeGroup}
              placeholder={language_vn.chooseGroup}
              showOptionAll
            />
          </Col>
          <Col sm={6}>
            <VVSSelectModel
              name="salesStaff"
              model="Employee"
              {...rest}
              conditionField={{
                group: {
                  objectId: employeeGroup?.objectId,
                  className: "EmployeeGroup",
                  __type: "Pointer",
                },
              }}
              onSelect={setEmployee}
              placeholder={language_vn.chooseEmployee}
              showOptionAll
            />
          </Col>
        </Row>
      </form>
      <Container fluid>
        <VVSTable
          name="Lead"
          showImportExcel
          showExportExcel
          showAllotmentLead
          pointer="Employee"
          template={template.lead}
          whereQuery={getFilterLead(employeeGroup, employee)}
        />
      </Container>
    </div>
  );
};

export default Lead;
